import { Pipe, PipeTransform } from '@angular/core';

/**
 * transform the seconds with the format mm:ss
 */

@Pipe({
  name: 'chrono',
})
export class ChronoPipe implements PipeTransform {
  transform(seconds: number, showHour: boolean): string {
    if (showHour) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;

      return `${hours >= 10 ? '' : '0'}${hours}:${
        minutes >= 10 ? '' : '0'
      }${minutes}:${secs >= 10 ? '' : '0'}${secs}`;
    } else {
      const minutes = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${minutes >= 10 ? '' : '0'}${minutes} : ${
        secs >= 10 ? '' : '0'
      }${secs}`;
    }
  }
}
